export default __webpack_public_path__ + "static/media/nowires.9353a4fe.apk";